import React from "react";
import { Container, Row, Col, Card } from "reactstrap";
import { Target } from "lucide-react";
import {
  SA_PRIMARY,
  SA_SECONDARY,
  saReadableText,
  saGradientLine,
  saDarkCardBase,
  saCardBgHover,
  onDarkCardLeave,
} from "./saSectionTokens";
import { EVENT_LOCATION } from "../../constants";

function SAClosingVisionSection() {
  const size =
    document.body.clientWidth >= 928 || document.documentElement.clientWidth >= 928;

  return (
    <section className="section py-5" style={{ background: "transparent", position: "relative", zIndex: 1 }}>
      <Container>
        <Row className="justify-content-center">
          <Col lg={10} xl={8}>
            <Card
              style={{
                ...saDarkCardBase,
                border: `1px solid ${SA_PRIMARY}40`,
                borderRadius: "20px",
                padding: size ? "2.5rem" : "1.75rem",
                overflow: "hidden",
                position: "relative",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = saCardBgHover;
              }}
              onMouseLeave={onDarkCardLeave}
            >
              <div className="d-flex align-items-start mb-3" style={{ gap: "1.1rem" }}>
                <div
                  style={{
                    width: size ? 56 : 48,
                    height: size ? 56 : 48,
                    minWidth: size ? 56 : 48,
                    borderRadius: "16px",
                    background: `linear-gradient(145deg, ${SA_PRIMARY}30, ${SA_SECONDARY}20)`,
                    border: `2px solid ${SA_PRIMARY}55`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Target size={size ? 28 : 24} strokeWidth={2} style={{ color: SA_PRIMARY }} />
                </div>
                <h2
                  className="text-white mb-0"
                  style={{
                    fontSize: size ? "2rem" : "1.55rem",
                    fontWeight: 700,
                    letterSpacing: "0.05em",
                    textTransform: "uppercase",
                    color: SA_PRIMARY,
                    lineHeight: 1.2,
                    ...saReadableText,
                  }}
                >
                  Shaping the Kingdom&apos;s Digital Future
                </h2>
              </div>
              <p
                className="mb-4"
                style={{
                  fontSize: size ? "1.12rem" : "1rem",
                  lineHeight: 1.8,
                  ...saReadableText,
                }}
              >
                As Saudi Arabia continues to redefine global standards in urban innovation,
                infrastructure delivery and smart city development, KINGDOM DIGITAL TWIN 2026
                provides the premier platform to connect industry leaders, showcase innovation and
                accelerate the adoption of Digital Twin technologies across the Kingdom.
              </p>
              <p
                className="mb-0"
                style={{
                  fontSize: size ? "1.08rem" : "0.98rem",
                  lineHeight: 1.75,
                  fontWeight: 600,
                  color: SA_SECONDARY,
                  ...saReadableText,
                }}
              >
                Join over 200+ senior decision-makers, 30+ expert speakers and leading technology
                innovators at {EVENT_LOCATION} to shape the next generation of intelligent
                infrastructure, sustainable cities and digitally connected communities.
              </p>
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: "4px",
                  ...saGradientLine,
                  opacity: 0.85,
                }}
              />
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default SAClosingVisionSection;
